// extracted by mini-css-extract-plugin
export default {"row":"SlidesIndicatorDesktop_row__MjljN","thumbnail":"SlidesIndicatorDesktop_thumbnail__ODNlM","image":"SlidesIndicatorDesktop_image__ZDNjN"};